import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ConfirmBtnAccCreation from "../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../components/_utils/AccountCreationComponents/PanDetails";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import {
  beneVerifyThisGST,
  resetBeneVerifyThisGst,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import CommonToast from "../../../_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import ActiveInactiveAssociatePopup from "../../../_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../_utils/CommonLayout";
import RejectingTransactionPopup from "../../../../containers/Accounts/BeneficiaryAccount/BeneficiaryAcountApproval/RejectingTransactionPopup/RejectingTransactionPopup";

const CreateFieldForcePanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  setLookupNext,
  lookupNext,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  accountType,
  setAccountType,
  setShutViewAll,
  disableCreateNext,
  setDisableCreateNext,
  type,
  previousId,
  beneLookError,
  setHideBlock,
  setHideCreate,
  hideBlock,
  nonArchive,
  setPreviousBankNo,
  isLinkedAccount,
  alreadyLinked,
  setPayload,
  payload,
  setShowAccInfo,
  handleDeSelectConfirm,
  showRejectTnxPopup,
  setRejectTxnPopup,
  setShowRejectAllTxnReson,
  GSTStatus,
  setGSTStatus,
  setNewData,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTLinked, setGSTLinked] = useState(false);
  const dropDownOptions = [
    "Field force account",
    "Beneficiary account",
    "Reimbursement account",
    "Tax account",
  ];

  const dispatch = useDispatch();
  const associatedAccountRef = useRef(null);

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { beneVerifyGST, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  useEffect(() => {
    if (payload?.gstin?.length === GlobalConfiguration.gstLength) {
      let aa = payload.gstin.substring(
        GlobalConfiguration.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration.lengthCheckThree,
      );
      if (aa === panNumber && beneVerifyGST?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa != panNumber && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (
      payload?.gstin?.length === GlobalConfiguration.lengthCheckZero &&
      verifiedPan &&
      !verifyPANisLoading
    ) {
      setGSTStatus(null);
    }
  }, [
    beneVerifyGST,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(
        GlobalConfiguration.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration.lengthCheckThree,
      );
      if (!GSTStatus && GSTStatus != null) {
        BenEnableNextButton(true);
      } else if (GSTStatus && disableCreateNext && aa === panNumber) {
        BenEnableNextButton(false);
      }
    }
  }, [GSTStatus]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(
        GlobalConfiguration.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration.lengthCheckThree,
      );
      if (
        verifiedPan === true &&
        GSTStatus &&
        payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
        payload?.gstin?.length === GlobalConfiguration.gstLength &&
        gstVerified === true &&
        aa === panNumber
      ) {
        BenEnableNextButton(false);
      } else if (
        !beneLookLoading &&
        !verifyPANisLoading &&
        beneLookError === true &&
        verifiedPan &&
        panNumber?.length === GlobalConfiguration.panLength &&
        payload?.gstin?.length === GlobalConfiguration.lengthCheckZero
      ) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    }
  }, [gstVerified, GSTStatus]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData =
        viewAccountDetailData?.beneficiary_accounts?.[
          GlobalConfiguration?.lengthCheckZero
        ];
      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,

          gstin: beneficiaryData?.gstin_detail || "",
        }));

        if (beneficiaryData?.gstin) {
          dispatch(
            beneVerifyThisGST({
              gstin: beneficiaryData?.gstin,
            }),
          );
        }
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration.gstLength &&
      !customErrors["gstin"]
    ) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(beneVerifyThisGST({ search_string: payload.gstin }));
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (!isGSTLoading) {
      if (beneVerifyGST?.status === true) {
        setGstVerified(true);
      } else if (beneVerifyGST?.status === false) {
        setGstVerified(false);
      } else {
        setGstVerified(null);
      }
    }
  }, [beneVerifyGST, isGSTLoading]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value.length === GlobalConfiguration.lengthCheckZero
      ) {
        return;
      }

      if (
        newValue.length < GlobalConfiguration.gstLength &&
        newValue.length > GlobalConfiguration.lengthCheckZero
      ) {
        setGstVerified(false);
        setGSTStatus(false);
        setGSTLinked(false);
      }

      if (name === "gstin") {
        setLookupNext(false);
        dispatch(resetBeneVerifyThisGst());
        if (
          name === "gstin" &&
          newValue.length < GlobalConfiguration.gstLength &&
          newValue.length > GlobalConfiguration.lengthCheckZero &&
          !gstVerified &&
          GSTStatus
        ) {
          setGSTStatus(false);
        } else if (
          newValue.length === GlobalConfiguration.gstLength &&
          gstVerified &&
          !GSTStatus
        ) {
          setGSTStatus(true);
        }
      }
    }
  };

  useEffect(() => {
    if (
      payload.gstin?.length > GlobalConfiguration.lengthCheckZero &&
      payload.gstin?.length === GlobalConfiguration.gstLength &&
      beneVerifyGST?.status === true
    ) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (
      payload.gstin?.length > GlobalConfiguration.lengthCheckZero &&
      beneVerifyGST?.errors
    ) {
      let errors = { ...customErrors };
      errors["gstin"] = beneVerifyGST.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [beneVerifyGST]);

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account archived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[
              GlobalConfiguration.lengthCheckZero
            ][GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });

          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setAccountType({ type: "", id: "", name: "" });
        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[
              GlobalConfiguration.lengthCheckZero
            ][GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  useEffect(() => {
    if (beneVerifyGST?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: beneVerifyGST?.gstin_details?.business_name,
      });
    }
  }, [beneVerifyGST]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const handleClosePopup = () => {
    setRejectTxnPopup(false);
    setShowRejectAllTxnReson(false);
  };
  const isPanValid = verifiedPan === true;

  const isGstValid =
    payload?.gstin?.length === 0 || // GST optional
    (payload?.gstin?.length === GlobalConfiguration.gstLength &&
      GSTStatus === true);

  const isConfirmDisabled = !isPanValid || !isGstValid;

  return (
    <div className="w-width-full ">
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: beneVerifyGST?.gstin_details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={beneVerifyGST?.gstin_details?.gstin_no}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md pb-padding-md Qsmd:py-padding-base">
        {showRejectTnxPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop !bg-opacity-dark-opacity">
            <RejectingTransactionPopup
              type={"ArchiveAccount"}
              accountId={accountType.id}
              accountName={accountType.name}
              handleClosePopup={handleClosePopup}
              setShowRejectAllTxnReson={setShowRejectAllTxnReson}
              setRejectTxnPopup={setRejectTxnPopup}
              flow={"edit"}
              setIsDennied={setIsDennied}
              setIsPending={setIsPending}
              setIsApproved={setIsApproved}
              setIsArchived={setIsArchived}
              setShutViewAll={setShutViewAll}
            />
          </div>
        )}
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] z-z-index-base">
            {isLinkedAccount || alreadyLinked ? (
              <div className="new_message_text_block_nonarchive">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                />
                <p>
                  Looks like this PAN is already linked to this account. Please
                  change provided PAN details to proceed.
                </p>
              </div>
            ) : nonArchive ? (
              <div className="new_message_text_block_nonarchive">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                />
                <p>
                  Archiving this account is disabled. As you're currently
                  editing this account, archiving cannot be performed.
                </p>
              </div>
            ) : hideBlock ? (
              <div className="new_message_text_block_nonarchive">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : null}

            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePanChange(e);
              }}
              panDetails={panDetails}
            />
            <div
              className="w-width-full"
              style={{
                display: type == "createFlow" && !verifiedPan ? "none" : "",
              }}
            >
              <GstDetails
                verifiedPan={verifiedPan}
                gstVerified={gstVerified}
                beneVerifyGST={beneVerifyGST}
                isGSTLoading={isGSTLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload?.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleChange}
              />
            </div>
          </div>
          {verifiedPan === true ? (
            <div className="w-width-full flex flex-col lg:max-w-[var(--create-box-width)]">
              <ConfirmBtnAccCreation
                type="pan"
                status={beneLookData?.status}
                lookupNext={lookupNext}
                GSTStatus={GSTStatus}
                isButtonDisabled={isConfirmDisabled}
                isGSTLoading={isGSTLoading}
                selected={
                  "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                }
                not_selected={
                  "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                }
                handleClick={() => {
                  if (isConfirmDisabled) return;
                  setIsApproved(false);
                  setLookupNext(true);
                  setIsArchived(false);
                  setIsDennied(false);
                  setIsPending(false);
                  setDisableCreateNext(false);
                  setHideBlock(false);
                  if (lookupNext) {
                    setHideCreate(false);
                    handleDeSelectConfirm();
                  } else {
                    setHideCreate(true);
                  }
                  setAccountType({ type: "", id: "", name: "" });
                  setDisableCreateNext(true);
                }}
              />

              <div
                style={{
                  visibility:
                    (beneLookData?.status &&
                      panNumber?.length === GlobalConfiguration.panLength) ||
                    (!beneLookLoading &&
                      !verifyPANisLoading &&
                      beneLookError === true &&
                      verifiedPan &&
                      panNumber?.length === GlobalConfiguration.panLength)
                      ? "visible"
                      : "hidden",
                }}
              >
                <ActiveInactiveAssociatePopup
                  flow={
                    !beneLookLoading &&
                    !verifyPANisLoading &&
                    beneLookError === true &&
                    verifiedPan &&
                    panNumber?.length === GlobalConfiguration.panLength
                      ? "notFoundPan"
                      : "Pan"
                  }
                  dropDownOptions={dropDownOptions}
                  pan={payload?.panNumber}
                  accActiveInactiveState={accActiveInactiveState}
                  setAccActiveInactiveState={setAccActiveInactiveState}
                  currentAssociate={currentAssociate}
                  setCurrentAssociate={setCurrentAssociate}
                  openAssociatePopup={openAssociatePopup}
                  setOpenAssociatePopup={setOpenAssociatePopup}
                />
              </div>
            </div>
          ) : (
            <div
              className="w-width-full"
              style={{
                visibility: "hidden",
              }}
            ></div>
          )}
        </CommonLayout>
      </div>
    </div>
  );
};
export default CreateFieldForcePanDetails;
